module.exports = __webpack_public_path__ + "static/media/pa-icon-white.eb9a7c11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pa-icon-white.svg
// module id = ./src/assets/images/pa-icon-white.svg
// module chunks = 0